import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SALON_HUB_PATH } from '../config/salonApp';
import { readFaceSalonProfile } from '../utils/bootstrapFaceSalonSession';
import { readVisitHandoff } from '../utils/visitHandoff';

const HUB_THUMB = '/hub/skin.png';

export default function ServiceSessionHubChooseCard({
  checkinId,
  to,
  title = 'Try skin & hair analysis',
  sub = "We'll suggest what fits",
  cta = 'Get started →',
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const openHub = useCallback(() => {
    if (to) {
      navigate(to, { state: location.state || {} });
      return;
    }
    const handoff = readVisitHandoff();
    const profile = readFaceSalonProfile(location.state);
    navigate(SALON_HUB_PATH, {
      state: {
        ...(location.state || {}),
        checkinId: checkinId || location.state?.checkinId || handoff?.checkinId || null,
        customerName: location.state?.customerName || profile.name || handoff?.customerName || '',
        mobile: location.state?.mobile || profile.mobile || handoff?.mobile || '',
        faceUserId: location.state?.faceUserId || profile.faceUserId || handoff?.faceUserId || '',
        fromStylistDesk: Boolean(location.state?.fromStylistDesk),
      },
    });
  }, [checkinId, location.state, navigate, to]);

  return (
    <div className="salon-service-start__hub-choose salon-service-start__hub-choose--featured">
      <span className="salon-service-start__hub-choose-aura" aria-hidden="true" />
      <span className="salon-service-start__hub-choose-flare" aria-hidden="true" />
      <button
        type="button"
        className="salon-service-start__hub-choose-card salon-service-start__hub-choose-card--banner"
        onClick={openHub}
      >
        <span className="salon-service-start__hub-choose-shine" aria-hidden="true" />
        <div className="salon-service-start__hub-choose-art-wrap">
          <img
            className="salon-service-start__hub-choose-art"
            src={HUB_THUMB}
            alt=""
            aria-hidden="true"
            decoding="async"
          />
        </div>
        <div className="salon-service-start__hub-choose-copy">
          <p className="salon-service-start__hub-choose-eyebrow">
            <span className="salon-service-start__hub-choose-star" aria-hidden="true">✦</span>
            Not sure what to choose?
          </p>
          <p className="salon-service-start__hub-choose-title">{title}</p>
          <p className="salon-service-start__hub-choose-sub">{sub}</p>
          <span className="salon-service-start__hub-choose-cta">{cta}</span>
        </div>
      </button>
    </div>
  );
}
